module.exports = __webpack_public_path__ + "img/logo.1d7f0436.png";